<template>
  <div :class="b()">
    <div :class="b('component')">
      <input
          :class="b('search')"
          type="text"
          v-model="searchValue"
          @input="getSuggestions"
          @keyup.esc="stopSuggestions"
          :placeholder="placeholder"
      />

      <div :class="b('icon-container')">
        <svg alt="Search" class="search-icon" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
          <title>Search</title>
          <path
              d=" M6.02945,10.20327a4.17382,4.17382,0,1,1,4.17382-4.17382A4.15609,4.15609, 0,0,1,6.02945,10.20327Zm9.69195,4.2199L10.8989,9.59979A5.88021,5.88021, 0,0,0,12.058,6.02856,6.00467,6.00467,0,1,0,9.59979,10.8989l4.82338, 4.82338a.89729.89729,0,0,0,1.29912,0,.89749.89749,0,0,0-.00087-1.29909Z ">
          </path>
        </svg>
      </div>
      <dynamic-link :type="suggestionsComponent" :data="{searchSuggestions, searchValue}"></dynamic-link>
    </div>
  </div>
</template>

<script>
    import LoadService from "../mixins/load-service";

    const COMPONENT_NAME = "catalog-nav-search";

    export default {
        name: COMPONENT_NAME,
        props: [
                'suggestionsComponent',
                'role'
        ],
        mixins: [LoadService],
        data() {
            return {
                searchValue: '',
                suggestionAttribute: 'title',
                searchSuggestions: {
                },
                placeholder: 'Начните вводить запрос...'
            };
        },
        mounted() {
            let query = this.$route.query;
            if (query.hasOwnProperty('search')) {
                this.searchValue = query['search'];
            }
        },
        methods: {
            getSuggestions: _.debounce(async function () {
                if (this.searchValue.length === 0) {
                   this.searchSuggestions = {};
                    return;
                }

                let response = await this.service.search(this.searchValue);
                  this.searchSuggestions = response.result;
            }, 700),
          stopSuggestions() {
              this.searchSuggestions = {};
          }
        }
    }
</script>

<style lang="scss" scoped>
  .catalog-nav-search {
    display: flex;
    flex-wrap: wrap;
    clear: both;
    width: 100%;

    &__search {
      width: 100%;
      height: 42px;
      background-color: rgb(250, 250, 250);
      font-size: 0.9rem;
      padding: 8px 12px 8px 32px;
      border-width: 1px;
      border-style: solid;
      border-color: rgb(204, 204, 204);
      border-image: initial;
      border-radius: 0;
      outline: none
    }

    &__icon-container {
      position: absolute;
      top: calc(50% - 8px);
      cursor: pointer;
      padding-left: 12px;
      left: 0;

      .search-icon {
        fill: #0b93d5;
      }
    }

    &__component {
      width: 100%;
      position: relative;
    }
  }

</style>